// The whole i18n runtime. Deliberately dependency-free — the portal proves ~40
// lines is enough, and this bundle ships to a buyer's phone over mobile data.
//
// Mirrors apps/web/src/i18n/index.ts in imersivo-studio so both repos read the
// same way, with one addition the viewer needs: `{placeholder}` interpolation,
// because the viewer composes strings at runtime ("Variações (3/7)") in a way
// the portal does not.

import { ptBR, type Dict, type DictKey } from './pt-BR.ts';
import { en } from './en.ts';

export type { Dict, DictKey };
/** Both catalogues, for the few consumers that need every language at once
 *  rather than the active one — the voice menu index is the case: a headset
 *  visitor cannot open a language picker they cannot see. */
export { ptBR, en };
export const ALL_DICTS: readonly Dict[] = [ptBR, en];
export type Locale = 'pt-BR' | 'en';

export const LOCALES: Locale[] = ['pt-BR', 'en'];
export const DEFAULT_LOCALE: Locale = 'pt-BR';
export const LOCALE_STORAGE_KEY = 'imersivo:locale';

const dicts: Record<Locale, Dict> = { 'pt-BR': ptBR, en };

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as string[]).includes(value);
}

export type TVars = Record<string, string | number>;
export type TFn = (key: DictKey, vars?: TVars) => string;

const cache = new Map<Locale, TFn>();

/**
 * Returns the translator for a locale. The identity is stable per locale so
 * MenuHost and VrMenu3D can hold on to it and compare cheaply.
 *
 * Falls back key → pt-BR → the key itself. A missing translation therefore
 * degrades to a real Portuguese sentence rather than to `menu.narrator`, which
 * matters because the operator/editor strings are translated last.
 */
export function getT(locale: Locale): TFn {
  const hit = cache.get(locale);
  if (hit) return hit;

  const dict = dicts[locale] ?? ptBR;
  const t: TFn = (key, vars) => {
    const raw = dict[key] ?? ptBR[key] ?? key;
    return vars ? interpolate(raw, vars) : raw;
  };
  cache.set(locale, t);
  return t;
}

function interpolate(template: string, vars: TVars): string {
  return template.replace(/\{(\w+)\}/g, (whole, name: string) => {
    const v = vars[name];
    return v === undefined ? whole : String(v);
  });
}
